import React, { useEffect, useState } from 'react';
import { node } from 'prop-types';
import { useLocation } from 'react-router-dom';

export const LocationContext = React.createContext();

const LocationProvider = (props) => {
  const { children } = props;

  const [state, setState] = useState({
    location: null,
    referrer: null,
    history: [],
  });
  const location = useLocation();

  useEffect(() => {
    const prevLocation = state.history[state.history?.length - 1] || null;
    const newLocation = {
      ...location,
      fullPath: `${location.pathname}${location.hash}`,
    };

    setState({
      location: newLocation,
      referrer: prevLocation,
      history: [...state.history, newLocation],
    });
  }, [location]);

  return (
    <LocationContext.Provider value={state}>
      {children}
    </LocationContext.Provider>
  );
};

LocationProvider.propTypes = {
  children: node.isRequired,
};

export default LocationProvider;
